<div class="modal timer-alert-modal" [class.fr]="isFrench">
  <div class="model-container">
    <div class="modal-header">
      <h3 class="modal-heading">{{ data.title }}</h3>
      <img class="modal-close" (click)="closeDialog()" src="/assets/icon/primary-close.svg" alt="close-icon" width="28"
        height="28">
    </div>
    <div class="modal-body">
     <div class="note" *ngIf="!!data.timer">
        <p class="details">{{ minutes }}:{{ (seconds < 10 ? ('0' + seconds) : seconds) }} <span translate>alert-security-modal.minutes-remaining</span></p>
      </div>
      <div class="contents" [innerHTML]="data.customHTML"></div>
      <div class="modal-actions">
        <button class="button primary" aria-label="stay connected" (click)="primary()">{{ data.primaryText }}</button>
        <button class="button secondary" aria-label="Log out" (click)="secondary()">{{ data.secondaryText }}</button>
      </div>
    </div>
  </div>
</div>
